<template>
    <div class='menu-item' :class="[ { 'active': (path == currentPath || currentRoute == true) }, { name: true } ]" @click='navigate'>
        <div class='menu-icon'>
            <DisplayIcon
                :icon='icon'
            />
        </div>
        <span v-if='openMenu == true'>{{ title }}</span>
    </div>
</template>

<script>
    import DisplayIcon from '../../../icons/DisplayIcon'
    export default {
        name: 'MenuItem',
        props: ['path', 'title', 'icon', 'isOpen'],
        components:{
            DisplayIcon
        },
        computed: {
            openMenu(){
                return this.$props.isOpen;
            },
            currentPath(){
                return this.$route.path;
            },
            currentRoute(){
                return (this.$route.meta.breadcrumb.findIndex(x => x.name == this.$props.title) === 1) ? true : false
            },
            formattedName(){
                return  this.$route.meta.title;
            }
        },
        methods: {
            navigate(e){
                if(this.$props.path != this.currentPath) this.$router.push(this.$props.path);
            }
        }
    }
</script>
